var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contract-progress"},[_c('div',{staticClass:"ms-help label"},[_vm._v("\n    "+_vm._s(_vm.getLabel())+"\n  ")]),_c('i-progress',{attrs:{"stroke-width":12,"percent":_vm.getPercentile(_vm.part, _vm.all),"hide-info":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }